import { defineMessages } from 'react-intl'

export default defineMessages({
  description: {
    id: 'containers.CustomerOrderUpsertPage.components.LandingPageLink.description',
    defaultMessage: 'We have prepared a landing page with your files where you can listen to them.\nYou can share this link with clients and colleagues. ',
  },
  copySuccess: {
    id: 'containers.CustomerOrderUpsertPage.components.LandingPageLink.copySuccess',
    defaultMessage: 'Copied link',
  }
})